<!-- 质量管理 圆环图 -->
<template>
  <div>
    <div class="circle-wrapper">
      <div class="circle-content" :id="id"></div>
      <div class="title">{{title}}</div>
      <div class="content">
        <span :class="beforeT>=100 || beforeT=='无数据'?'sp11':'sp1'" >{{beforeT}}</span>
        <span class="sp2">.{{afterT}}{{unit}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["color", "percent", "id", "title", "content", "unit", "name1", "name2"],
  data() {
    return {
      beforeT:0,
      afterT:0,
    };
  },
  computed: {},
  created() {},
  mounted() {
    const echarts = require("echarts");
    const myChart = echarts.init(document.getElementById(this.id));
    //console.log(this.content)
    //console.log(this.percent)
    let getP = this.percent
    let getPA = getP.split(".")
    this.beforeT = getPA[0]
    this.afterT = getPA[1]
    let that = this
    const option = {
      tooltip: {
          trigger: 'item',
          position:'right',
          // formatter: '{a} <br/>{b}: {c}' + this.unit
          formatter: function(){
            var res=option.series[0].name+'<br />';
            var myseries=option.series;
            for(var i=0;i<myseries.length;i++){
                //在内部继续循环series[i],从data中判断：当地区名称等于params.name的时候就将当前数据和名称添加到res中供显示
                for(var k=0;k<myseries[i].data.length;k++){
                    ////console.log(myseries[i].data[k].name);
                    //如果data数据中的name和地区名称一样
                    // if(myseries[i].data[k].name==params.name){
                        //将series数据系列每一项中的name和数据系列中当前地区的数据添加到res中
                        res+=myseries[i].data[k].name+':'+myseries[i].data[k].value+that.unit+'<br />';
                    // }
                }
            }
            //console.log(res)
            return res
          }
      },
      series: [
        {
          name: this.title.substring(2),
          type: "pie",
          radius: ["70%", "100%"],
          avoidLabelOverlap: false,
          hoverAnimation: false,
          label: {
            show: false,
            position: "center",
          },
          emphasis: {
            label: {
              show: false,
              fontSize: '14',
              fontWeight: 'bold'
            },
          },
          labelLine: {
            show: false,
          },
          data: [
            {
              value: this.percent,
              name: this.name1,
              itemStyle: { color: this.color },
            },
            {
              value: this.content,
              name: this.name2,
              itemStyle: { color: "#e1e1eb" },
            },
          ],
        },
      ],
    };
    myChart.setOption(option);
  },
  methods: {},
  components: {},
};
</script>

<style lang="scss" scoped="">
.circle-wrapper {
  position: relative;
}
.circle-content {
  width: 100px;
  height: 100px;
  margin: 0 auto;
}
.title {
  font-size: 13px;
  line-height: 2;
  text-align: center;
  margin: 5px auto 10px;
}
.content {
  position: absolute;
  width: 100%;
  top: 37px;
  // left: 28px;
  text-align: center;
  .sp1 {
    font-size: 24px;
    font-weight: bold;
  }
  .sp11 {
    font-size: 18px;
    font-weight: bold;
  }
  .sp2 {
    margin-left: 2px;
    font-size: 12px;
  }
}
</style>